import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useProviderStore } from "@/stores/providerStore";
import { useAuthStore } from "@/stores/authStore";

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { exchangeCode } = useProviderStore();
  const { user } = useAuthStore();

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error");

    if (error) {
      console.error("OAuth error:", error);
      navigate("/settings");
      return;
    }

    if (!code || !state) {
      navigate("/settings");
      return;
    }

    // Determine provider from state or use stored mapping
    // For simplicity, try both providers
    const provider = (sessionStorage.getItem("oauth_provider") as "gmail" | "outlook") || "gmail";

    exchangeCode(provider, code)
      .then(() => {
        sessionStorage.removeItem("oauth_provider");
        navigate(user?.providerConnected ? "/library" : "/onboarding");
      })
      .catch((err) => {
        console.error("OAuth exchange failed:", err);
        navigate("/settings");
      });
  }, [searchParams, navigate, exchangeCode, user]);

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-gray-500">Connecting your account…</p>
    </div>
  );
}
